import { cn } from "@/lib/utils";

/**
 * Anivora's A mark, drawn as a path so it looks identical in every font and
 * on every system. Sized in em and coloured by `currentColor` like a letter.
 */
export function LogoGlyph({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" aria-hidden className={cn("size-[1.15em] shrink-0", className)} fill="none">
      <path d="M24 5 43 42h-9L24 20 14 42H5L24 5Z" fill="currentColor" />
      <path d="M15 30h18v5H15z" fill="var(--brand-blue, currentColor)" />
    </svg>
  );
}
